import BaseDataObject from './BaseDataObject';

// GameInformation sulky info
export default class SulkyInfo extends BaseDataObject {
  getSulkyCode() {
    return this.getString('sulkyCode');
  }

  getSulkyName() {
    return this.getString('sulkyName');
  }

  getLastRaceSulkyCode() {
    return this.getString('lastRaceSulkyCode');
  }

  getLastRaceSulkyName() {
    return this.getString('lastRaceSulkyName');
  }

  isAvailable() {
    return this.getBoolean('sulkyInfoAvailable');
  }

  getSulkyChange() {
    return (
      (this.has('sulkyCode') && !this.has('lastRaceSulkyCode')) ||
      this.getSulkyCode() !== this.getLastRaceSulkyCode()
    );
  }
}
